<template>
  <div v-if="hasPartners">
    <div class="marker-info-label marker-info-label-partners">Partners</div>
    <div class="partners" v-html="areaPartners"/>
    <div v-if="marker" class="marker-partners" v-html="selected_marker.partners"></div>
  </div>
</template>

<script setup lang="ts">

import {computed} from "vue";

const props = defineProps({
  selected_marker: Object,
  marker: {
    type: Boolean,
    default: false
  },
  program: {
    type: Boolean,
    default: true
  }
});

const hasPartners = computed(() => {
  return props.selected_marker.partners != ''  || props.selected_marker.area_partners != ''  ||  props.selected_marker.program_partners != '';
})

const areaPartners = computed(() => {
  if(props.program == false) {
    return props.selected_marker.area_partners
  }
  return props.selected_marker.area != '' && props.selected_marker.area_partners != ''  ? props.selected_marker.area_partners : props.selected_marker.program_partners;
})
</script>
